import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, func, node, number, oneOfType, shape, string,
} from 'prop-types'

function OptionGroup({ id, label, options, value, onChange }) {
  const labelId = `${id}-label`

  return (
    <div className="generation-settings__row">
      <span id={labelId} className="generation-settings__row-label cgt-body-base-semibold">{label}</span>
      <div className="generation-settings__options" role="group" aria-labelledby={labelId}>
        {options.map((option) => {
          const isSelected = option.value === value
          return (
            <button
              key={option.value}
              type="button"
              className={classnames(
                'generation-settings__option cgt-caption-semibold',
                isSelected && 'generation-settings__option--selected',
              )}
              aria-pressed={isSelected}
              onClick={() => onChange(option.value)}
            >
              {option.icon}
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

const valueType = oneOfType([string, number])

OptionGroup.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  options: arrayOf(shape({
    value: valueType.isRequired,
    label: string.isRequired,
    icon: node,
  })).isRequired,
  value: valueType.isRequired,
  onChange: func.isRequired,
}

export default memo(OptionGroup)
